
import React, { Fragment } from "react";

import SweetAlert from 'sweetalert2';
import { toast } from "react-toastify";

import { roleService } from 'Services';
import TableRowDelete from 'CommonElements/Table/TableRowDelete';


const DeleteRole = ({ data={}, loadData }) => {


  const deleteRole = () => {
    SweetAlert.fire({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to recover this record!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            roleService.deleteRole(data.id).then(res => {
                toast.success('Role deleted, successfully');
                loadData();
            }).catch(err => {
                toast.error('Failed to delete Role');

            })
        }
    });
};
  return (
    <Fragment>
        <TableRowDelete onClick={deleteRole} />

    </Fragment>
  );
};

export default DeleteRole;
